var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('app-header'),_c('div',[_c('vue-page-transition',{attrs:{"name":"fade-in-up"}},[_c('router-view')],1)],1),_c('app-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }